<template>
  <div class="card-container">
    <common-top-form
      
      :model="formModel"
      :submitService="submitService"
      :selectShow="false"
      buttonName="审核"
      addShowPower="/copymerchantInfo/up"
      :show="true"
      @openAddDialog="openAddDialog"
      :submitData="submitData"
      @success="onSuccess"
      :gobackNew="true"
      @goBackNew="goBackNew"
      :clickShow="true"
      clickName="变更基础信息"
      clickSwitch="/copymerchantInfo/up"
      clickShowType="warning"
      @click="click"
       :clickShowOpen="true"
      clickNameOpen="变更开户信息"
      clickSwitchOpen="/copymerchantInfo/up"
      clickShowTypeOpen="warning"
      @clickOpen="clickOpen"
       :clickShowMoney="true"
      clickNameMoney="变更费率信息"
      clickSwitchMoney="/copymerchantInfo/up"
      clickShowTypeMoney="warning"
      @clickMoney="clickMoney"
      
    >
    </common-top-form>
    <div style="padding: 20px 0; font-weight: 700">基础信息</div>
    <common-table
      class="marginPx"
      :data="tableData"
      ref="commonTable"
      :isShow="false"
      :width="100"
    >
      <el-table-column
        prop="merNo"
        label="商户号"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merMode"
        label="商户经营类型"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.merMode == 0">企业</span>
          <span v-else-if="scope.row.merMode == 1">个体</span>
          <span v-else-if="scope.row.merMode == 2">小微</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="merName"
        label="注册名称"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="businName"
        label="经营名称(店名)"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merAddr"
        label="注册地址"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merAreaName"
        label="注册地区"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
       
          <el-table-column
        prop="remark"
        label="备注"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="mccSmallType"
        label="行业类别"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
         <el-table-column
        prop="businScope"
        label="主营业务"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="mccRemark"
        label="行业类型描述"
        min-width="200"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="standardFlag"
        label="行业大类"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.standardFlag == 0">标准</span>
          <span v-else-if="scope.row.standardFlag == 1">优惠</span>
          <span v-else-if="scope.row.standardFlag == 2">减免</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="employeeNum"
        label="公司规模"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.employeeNum == 1">0-50人</span>
          <span v-else-if="scope.row.employeeNum == 2">50-100人</span>
          <span v-else-if="scope.row.employeeNum == 3">100以上</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="businForm"
        label="经营形态"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.businForm == '01'">连锁店</span>
          <span v-else-if="scope.row.businForm == '02'">普通店</span>
        </template>
      </el-table-column>
    </common-table>
      <div style="padding: 20px 0; font-weight: 700">上游返回信息</div>
           <common-table
      class="marginPx"
      :data="tableData"
      ref="commonTable"
      :isShow="false"
     
    >
        <el-table-column
        style="word-wrap:break-word;"
        prop="retMsg"
        label="上游返回信息"
        min-width="200"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
          <template slot-scope="scope">
         <div style="white-space: wrap"> <span>{{scope.row.retMsg}}</span></div>
          
        </template></el-table-column>
     </common-table>
    <div style="padding: 20px 0; font-weight: 700">附加信息</div>

    <!-- 附加信息 -->
    <common-table
      :data="tableDataTwo"
      ref="commonTable"
      :isShow="false"
      :width="100"
    >
      <el-table-column
        prop="merLegal"
        label="法定代表人姓名"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="legalType"
        label="证件种类"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.legalType == 0">身份证</span>
          <span v-else-if="scope.row.legalType == 1">护照</span>
          <span v-else-if="scope.row.legalType == 2">港澳通行证</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="legalCode"
        label="证件号码"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="legalValidityStart"
        label="证件有效日期起"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="legalValidityEnd"
        label="证件有效日期止"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="legalPhone"
        label="法人手机号"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="linkMan"
        label="商户联系人姓名"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="linkmanCode"
        label="商户证件号码"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="linkmanValidityStart"
        label="商户证件有效日期起"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="linkmanValidityEnd"
        label="商户证件有效日期止"
        min-width="200"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="linkmanPhone"
        label="商户手机号"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
      </el-table-column>
    </common-table>
    <div style="padding: 20px 0; font-weight: 700">开户信息</div>
    <!-- 结算信息 -->
    <common-table
      :data="tableDataThree"
      ref="commonTable"
      :isShow="false"
      :width="100"
    >
      <el-table-column
        prop="accType"
        label="账户类型"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.accType == 0">个人</span>
          <span v-else-if="scope.row.accType == 10">对公</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="accName"
        label="姓名"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="account"
        label="卡号"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="bankCode"
        label="开户行行号"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="bankName"
        label="开户行名称"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      
    </common-table>
    <div style="padding: 20px 0; font-weight: 700">经营信息</div>
    <!-- 图片信息 -->
    <common-table
      :data="tableDataFour"
      ref="commonTable"
      :isShow="false"
      :width="100"
    >
      <el-table-column prop="imgOne" label="法人身份证人像面" min-width="150">
        <template slot-scope="scope">
          <image-viewer
            class="iconUrl"
            :src="scope.row.imgOne"
            alt="图片描述"
          ></image-viewer>
        </template>
      </el-table-column>

      <el-table-column prop="imgTwo" label="法人身份证国徽面" min-width="150">
        <template slot-scope="scope">
          <image-viewer
            class="iconUrl"
            :src="scope.row.imgTwo"
            alt="图片描述"
          ></image-viewer>
        </template>
      </el-table-column>
      <el-table-column prop="imgThree" label="银行卡照" min-width="150">
        <template slot-scope="scope">
          <image-viewer
            class="iconUrl"
            :src="scope.row.imgThree"
            alt="图片描述"
          ></image-viewer>
        </template>
      </el-table-column>
      <el-table-column prop="imgFour" label="收银台" min-width="150">
        <template slot-scope="scope">
          <image-viewer
            class="iconUrl"
            :src="scope.row.imgFour"
            alt="图片描述"
          ></image-viewer>
        </template>
      </el-table-column>
      <el-table-column prop="imgFive" label="内部环境照" min-width="150">
        <template slot-scope="scope">
          <image-viewer
            class="iconUrl"
            :src="scope.row.imgFive"
            alt="图片描述"
          ></image-viewer>
        </template>
      </el-table-column>
      <el-table-column prop="imgSix" label="营业场所门头照" min-width="150">
        <template slot-scope="scope">
          <image-viewer
            class="iconUrl"
            :src="scope.row.imgSix"
            alt="图片描述"
          ></image-viewer>
        </template>
      </el-table-column>
         <el-table-column prop="imgTen" label="清算授权书" min-width="150">
        <template slot-scope="scope">
          <image-viewer
            class="iconUrl"
            :src="scope.row.imgTen"
            alt="图片描述"
          ></image-viewer>
        </template>
      </el-table-column>
         <el-table-column prop="imgEleven" label="其他图片" min-width="150">
        <template slot-scope="scope">
          <image-viewer
            class="iconUrl"
            :src="scope.row.imgEleven"
            alt="图片描述"
          ></image-viewer>
        </template>
      </el-table-column>
    </common-table>
    <div style="padding: 20px 0; font-weight: 700">营业执照信息</div>
    <!-- 图片信息 -->
    <common-table
      :data="tableDataFour"
      ref="commonTable"
      :isShow="false"
      :width="100"
    >
      <el-table-column prop="imgOne" label="营业执照" min-width="150">
        <template slot-scope="scope">
          <image-viewer
            class="iconUrl"
            :src="scope.row.imgSeven"
            alt="图片描述"
          ></image-viewer>
        </template>
      </el-table-column>

      <el-table-column prop="imgTwo" label="门牌号" min-width="150">
        <template slot-scope="scope">
          <image-viewer
            class="iconUrl"
            :src="scope.row.imgEight"
            alt="图片描述"
          ></image-viewer>
        </template>
      </el-table-column>
      
     <el-table-column prop="imgNine" label="开户许可证" min-width="150">
        <template slot-scope="scope">
          <image-viewer
            class="iconUrl"
            :src="scope.row.imgNine"
            alt="图片描述"
          ></image-viewer>
        </template>
      </el-table-column>
     
    </common-table>
    <div style="padding: 20px 0; font-weight: 700">费率信息</div>
    <!-- 费率信息 -->
    <common-table
      :data="tableDataFive"
      ref="commonTable"
      :isShow="false"
      :width="100"
    >
      <el-table-column
        prop="funcId"
        label="类型"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.funcId == 2">支付宝</span>
          <span v-else-if="scope.row.funcId == 3">微信</span>
          <span v-else-if="scope.row.funcId == 12">银联二维码大额</span>
          <span v-else-if="scope.row.funcId == 14">银联二维码小额</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="calcVal"
        label="费率"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="dcalcVal"
        label="借记卡费率"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="ccalcVal"
        label="贷记卡费率"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="dstlmMaxAmt"
        label="借记卡封顶"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
    </common-table>
    <!-- 执照 -->
       <div style="padding: 20px 0; font-weight: 700">执照信息</div>
    <!-- 附加信息 -->
    <common-table
      :data="tableDataSix"
      ref="commonTable"
      :isShow="false"
      :width="100"
    >
   
      <el-table-column
        prop="merLic"
        label="执照编码"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
  
      <el-table-column
        prop="licName"
        label="注册名称"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
          <el-table-column
        prop="licAddr"
        label="注册地址"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="licValidityStart"
        label="营业执照有效日期起"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="licValidityEnd"
        label="营业执照有效日期止"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
   
    </common-table>
    <!-- 新增dialog -->
     <form-dialog
      ref="formDialog"
      :formDialogTitle="'审核'"
      :model="dialogModel"
      :submitData="dialogData"
 
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
    >
        <el-form-item label="状态" prop="status">
                <el-select v-model="dialogModel.status" style="width: 198px">
                    <el-option
                        v-for="item in hardwareTypeStatus"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
      </el-form-item>
        <el-form-item label="备注" prop="remark">
                <el-input
                    v-model="dialogModel.remark"
                    maxlength="200"
                    show-word-limit
                    type="textarea"
                    rows="3"
                ></el-input>
            </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import FormDialog from "../../dialog/FormDialog";
import ImageViewer from "../../dialog/ImageViewer";
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import AyiSheng from "service/AyiSheng";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";
export default {
  name: "",
  components: {
    CommonTopForm,
    CommonTable,
    ImageViewer,
    FormDialog,
  },
  
  data() {
    return {
      // 新增审核dialog
      dialogModel: {
        status: "4",
        id: "",
        remark: "", // 备注
      },
      dialogService: AyiSheng.getText,
      hardwareTypeStatus: [
        {
          name: "未提交",
          id: "0",
        },
        {
          name: "已提交",
          id: "1",
        },
        {
          name: "审核中",
          id: "2",
        },
        {
          name: "成功",
          id: "3",
        },
        {
          name: "失败",
          id: "4",
        },
      ],
      isPage: false,

      formModel: {},
      impiementall: {},
      submitService: AyiSheng.getListOne,
      submitServiceTwo: AyiSheng.getListTwo,
      submitServiceThree: AyiSheng.getListThree,
      submitServiceFour: AyiSheng.getListFour,
      submitServiceFive: AyiSheng.getListFive,
      submitServiceSix: AyiSheng.getAddList,
      tableData: [],
      tableDataTwo: [],
      tableDataThree: [],
      tableDataFour: [
        {
          imgOne: "",
          imgTwo: "",
          imgThree: "",
          imgFour: "",
          imgFive: "",
          imgSix: "",
          imgSeven: '',
          imgEight: '',
          imgNine: '',
          imgTen: '',
          imgEleven: ''
        },
      ],
      tableDataFive: [],
      tableDataSix: [],
      status: [
        {
          dictKey: "0",
          dictValue: "未启动",
        },
        {
          dictKey: "1",
          dictValue: "进行中",
        },
        {
          dictKey: "2",
          dictValue: "已结束",
        },
        {
          dictKey: "3",
          dictValue: "已完成",
        },
      ],
    };
  },
  mixins: [loadMixin, dialogMixin],
  computed: {
    submitData() {
      const params = {
        id: JSON.parse(this.$route.params.item).id,
      };
      return params;
    },
    submiDataNew() {
      const paramsNew = {
        uuid: JSON.parse(this.$route.params.item).id,
      };
      return paramsNew;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
 

    created() {
      console.log(this.$route.params,'this.$route.params')
    this.impiementall = JSON.parse(this.$route.params.item);
    if (this.$route.params.formModel) {
      this.formModel = JSON.parse(this.$route.params.formModel);
    }
  },
  mounted() {
    this.getList();
    this.getListTwo();
    this.getListThree();
    this.getListFour();
    this.getListFive();
    this.getListSix();
  },
  watch: {},
  methods: {
    click() {
      this.showConfirm("是否变更基础信息？")
        .then(() => {
          this.changeBase();
        })
        .catch(() => {});
    },
    changeBase() {
      this.doLoad(
        AyiSheng.changeBase,
        { id: this.dialogModel.id },
        (res) => {
          this.commonSuccess(res);
        },
        "变更基础信息失败"
      );
    },
    clickOpen() {
      this.showConfirm("是否变更开户信息？")
        .then(() => {
          this.changeOpen();
        })
        .catch(() => {});
    },
    goBackNew() {
      console.log(this.formModel,'this.formModel')
      this.$router.push({
        name: 'AyiSheng',
        params: {
          formModel: JSON.stringify(this.formModel)
        }
      })
    },
    changeOpen() {
      this.doLoad(
        AyiSheng.changeOpen,
        { id: this.dialogModel.id },
        (res) => {
          this.commonSuccess(res);
        },
        "变更基础信息失败"
      );
    },
    clickMoney() {
      this.showConfirm("是否变更费率信息？")
        .then(() => {
          this.changeMoney();
        })
        .catch(() => {});
    },
    changeMoney() {
      this.doLoad(
        AyiSheng.changeMoney,
        { id: this.dialogModel.id },
        (res) => {
          this.commonSuccess(res);
        },
        "变更基础信息失败"
      );
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
    },
    dialogClose() {
      this.dialogModel = {
        id: "",
        remark: "",
        status: "4",
      };
    },
    openAddDialog(item, flag) {
      this.$refs.formDialog.open();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData.push(result);
      });
    },

    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.dialogModel.id = res.contents.id;
          this.onSuccess(res);
          this.isPage = false;
        },
        "信息获取失败"
      );
    },
    getListTwo() {
      this.doLoad(
        this.submitServiceTwo,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.tableDataTwo.push(res.contents);
          });
        },
        "信息获取失败"
      );
    },
    getListSix() {
      this.doLoad(
        this.submitServiceSix,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.tableDataSix.push(res.contents);
          });
        },
        "信息获取失败"
      );
    },
    getListThree() {
      this.doLoad(
        this.submitServiceThree,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            console.log(res, "res");
            this.tableDataThree.push(res.contents);
          });
          console.log(this.tableDataThree, "this.tableDataThree");
        },
        "信息获取失败"
      );
    },
    getListFour() {
      this.doLoad(
        this.submitServiceFour,
        this.submiDataNew,
        (res) => {
          this.doCheck(res, (res) => {
            res.contents.forEach((item) => {
              if (item.picMode == "01") {
                this.tableDataFour[0].imgOne = item.filePath;
              } else if (item.picMode == "02") {
                this.tableDataFour[0].imgTwo = item.filePath;
              } else if (item.picMode == "14") {
                this.tableDataFour[0].imgThree = item.filePath;
              } else if (item.picMode == "06") {
                this.tableDataFour[0].imgFour = item.filePath;
              } else if (item.picMode == "07") {
                this.tableDataFour[0].imgFive = item.filePath;
              } else if (item.picMode == "08") {
                this.tableDataFour[0].imgSix = item.filePath;
              } else if (item.picMode == "05") {
                this.tableDataFour[0].imgSeven = item.filePath;
              } else if (item.picMode == "09") {
                this.tableDataFour[0].imgEight = item.filePath;
              } else if (item.picMode == "13") {
                this.tableDataFour[0].imgNine = item.filePath;
              } else if (item.picMode == "15") {
                this.tableDataFour[0].imgTen = item.filePath;
              } else if (item.picMode == "23") {
                this.tableDataFour[0].imgEleven = item.filePath;
              }
            });
           
          });
        },
        "信息获取失败"
      );
    },
    getListFive() {
      this.doLoad(
        this.submitServiceFive,
        this.submiDataNew,
        (res) => {
          this.doCheck(res, (res) => {
            console.log(res, "res");
            this.tableDataFive = res.contents;
          });
        },
        "信息获取失败"
      );
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/AyiShengFile/AyiShengChild.vue